import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import UsersPage from './UsersPage';
import AuthPage from './AuthPage';
import CreateUploadJD from './CreateUploadJD';
import PrivateRoute from "./PrivateRoute";
import AddApplicant from './AddApplicant';
import BulkUploadApplicants from './BulkUploadApplicants';
import CandidateDetails from './CandidateDetails';
import ResetPassword from './ResetPassword';
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';
import { AuthProvider } from './contexts/AuthContext';

function App() {
  /* return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>
    </div>
  );  */
  /* return (
    <div>
        <h1>Hiyaa User Management</h1>
        <UsersPage />

    </div>
  ); */
  return(
    <AuthProvider>
      <Router>
        <Analytics />
        <SpeedInsights />
        <Routes>
          {/* Default route redirects to AuthPage */}
          <Route path="/" element={<AuthPage />} />
          <Route path="/login" element={<AuthPage />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/users" element={<UsersPage />} />
          <Route path="/jd" element={
            <PrivateRoute>
              <CreateUploadJD />
            </PrivateRoute>
          } />
          <Route path="/add-applicant/:jobId" element={
            <PrivateRoute>
              <AddApplicant />
            </PrivateRoute>
          } />
          <Route path="/bulk-upload-applicants/:jobId" element={
            <PrivateRoute>
              <BulkUploadApplicants />
            </PrivateRoute>
          } />
          <Route path="/candidate/:candidateId" element={
            <PrivateRoute>
              <CandidateDetails />
            </PrivateRoute>
          } />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
